/**
 * Returns a random subset of items from an array
 *
 * @param array
 * @param subsetSize
 */
function getRandomSubset(array, subsetSize) {
    //Deep clone to preserve immutability
    array = JSON.parse(JSON.stringify(array));

    if (subsetSize > array.length) {
        subsetSize = array.length;
    }
    const shuffled = array.sort(() => .5 - Math.random()); // shuffle
    return shuffled.slice(0, subsetSize);
}

/**
 * If we are on a product page, remove the page product from the list of suggested products
 *
 * @param products
 * @returns {*}
 */
function filterOutPageProduct(products) {
    if (typeof window.pageProduct !== 'undefined') {
        products = products.filter(product => product.id !== window.pageProduct.productId);
    }
    return products;
}

/**
 * Remove any products from the given productId array
 *
 * @param products
 * @param productIds
 * @return {*}
 */
function filterOutProductsWithProductIdInArray(products, productIds) {
    return products.filter(product => !productIds.includes(product.id));
}

/**
 * Filter any items that are already in the current order from the suggested products
 *
 * @param products
 * @param orderItems
 */
function filterOutOrderItems(products, orderItems) {
    return products.filter((product) => {
        const matchingProduct = orderItems.find(
            (orderItem) => orderItem.sku.productId === product.id
        );
        return typeof matchingProduct !== 'object';
    });
}

/**
 * Filters out suggested products per the business rules
 *
 * @param products
 * @param subsetSize
 * @param orderItems
 * @param productIdsToFilterOut
 * @return {*}
 */
export default function filterSuggestedProducts(products, subsetSize, orderItems, productIdsToFilterOut) {
    products = filterOutPageProduct(products);
    products = filterOutOrderItems(products, orderItems);
    products = filterOutProductsWithProductIdInArray(products, productIdsToFilterOut);
    products = getRandomSubset(products, subsetSize);
    return products;
}
